import React from 'react';
import Link from 'next/link';
import styles from '../../styles/compare/OfferInfo.module.scss';
import Image from 'next/image';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { faCoins } from '@fortawesome/free-solid-svg-icons';
import { faUserShield } from '@fortawesome/free-solid-svg-icons';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { faArrowsAltV } from '@fortawesome/free-solid-svg-icons';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import * as gtag from '../../cookie/lib/gtag';
import BCTeaser from './BCTeaser';

const LoanInfo = (props) => {
    const { details, viewDetails, currency, sort, applyParams, type} = props;
    let fromApr, toApr, fromPayment, fromTotalCost, toTotalCost;
    if (details.interestScheme == 'dobanda_unica') {
        fromApr = <>{Intl.NumberFormat('fr', {maximumFractionDigits: 2}).format(details.apr)}%</>;
        toApr = null;
        fromPayment =   <>
                            {Intl.NumberFormat('fr', {maximumFractionDigits: 0}).format(details.monthlyPayment)}
                        </>;
        fromTotalCost = <>
                            {Intl.NumberFormat('fr', {maximumFractionDigits: 0}).format(details.totalAmount)}
                        </>;
    } else {
        fromApr = <><span className={styles.labelUpTo}>de la</span> {Intl.NumberFormat('fr', {maximumFractionDigits: 2}).format(details.apr)}%</>;
        toApr = <><span className={styles.labelUpTo}>până la</span> {details.aprMax}</>;
        fromPayment = <><span className={`${styles.labelUpTo} mr-1`}>de la</span> 
                        {Intl.NumberFormat('fr', {maximumFractionDigits: 0}).format(details.monthlyPayment)}
                    </>;
        fromTotalCost = <><span className={styles.labelUpTo}>de la</span> {Intl.NumberFormat('fr', {maximumFractionDigits: 0}).format(details.totalAmount)}
        </>;

        toTotalCost = <>
                            <span className={styles.labelUpTo}>până la</span> {Intl.NumberFormat('fr', {maximumFractionDigits: 0}).format(details.totalAmountMax)}
                        </>;
    }
    let relOpennerTag;
   
    if (details.hasOwnProperty('apply') && details.apply) {
        relOpennerTag = details.apply.indexOf(` ${process.env.NEXT_PUBLIC_SITE_URL} `) > -1 ? '' : 'noopener';
    } else if (details.hasOwnProperty('webLink') && details.webLink){
        relOpennerTag = details.webLink.indexOf(` ${process.env.NEXT_PUBLIC_SITE_URL} `) > -1 ? '' : 'noopener';
    } {
        relOpennerTag = '';
    }
    
    const onApply = () => {
       if (window.location.hostname.indexOf('conso.ro')>1) {
            gtag.event('Apply', {
                provider: details.provider,
                product: type,
            });
       } else {
           console.log("beta");
       }
    }

    let applyCol = details.hasOwnProperty('apply') && details.apply &&
                    <Col xs="6" md="4" className="d-flex justify-content-center align-items-center mt-2">
                        <Link href={ details.apply.indexOf(`${process.env.NEXT_PUBLIC_SITE_URL}`) > -1 ? 
                            `${details.apply}${applyParams ? '?'+ applyParams : ''}`
                            : 
                            details.apply
                            }
                        >
                            <a className="btn btn-primary" onClick={onApply}
                                rel={relOpennerTag}
                                target={details.apply.indexOf(`${process.env.NEXT_PUBLIC_SITE_URL}`) > -1 ? '_self' : '_blank'}>
                                Solicită ofertă
                                <FontAwesomeIcon className="ml-2" icon={faChevronRight} height="16" width="16" />
                            </a>
                        </Link>
                    </Col>;

    let webLinkCol = details.hasOwnProperty('webLink') && details.webLink &&
                    <Col xs="6" md="4" className="d-flex justify-content-center align-items-center mt-2">
                        <Link href={details.webLink}>
                            <a className="btn btn-link" 
                                rel={relOpennerTag}
                                target="_blank">
                                <FontAwesomeIcon className="mr-1 green" icon={faExternalLinkAlt} height="16" width="16" />
                                Website bancă
                            </a>
                        </Link>
                    </Col>;

    

    let incomeIcon = details.withIncome && 
                    <span className={styles.offerBenefit}>
                        <FontAwesomeIcon className={styles.offerBenefitIcon} icon={faCoins} /> Virare venit
                    </span>;
    let lifeInsuranceIcon = details.lifeInsurance && 
                    <span className={styles.offerBenefit}>
                        <FontAwesomeIcon className={styles.offerBenefitIcon} icon={faUserShield} /> Asigurare viață
                    </span>;
    let houseInsuranceIcon = details.houseInsurance && 
                    <span className={styles.offerBenefit}>
                        <FontAwesomeIcon className={styles.offerBenefitIcon} icon={faHome} /> Asigurare imobil
                    </span>;
    let benefitsCol =   <Col xs="12" md="8" className="pt-1">
                         {incomeIcon} {lifeInsuranceIcon} {houseInsuranceIcon}
                    </Col>;
    

    let aprColumn = 
                        <Col xs="4" className="p-2 text-center">
                            <p className={`${styles.indicator} `}>
                                DAE
                            </p>
                            <p className={`${styles.indicatorVal} ${sort=='apr' ? styles.active : ''}  mb-0`} suppressHydrationWarning>
                                {fromApr}
                            </p>
                                {toApr && 
                                
                                <div className={`${styles.indicatorVal} ${sort=='apr' ? styles.active : ''} mb-0 mt-2 `}>
                                    <p className="d-flex justify-content-center" >
                                        <FontAwesomeIcon icon={faArrowsAltV} className="d-block" width="16px" height="16px" />
                                    </p>
                                    {toApr}
                                </div> 
                            }
                        </Col>
                        ;

    let totalCostColumn = 
                        <Col xs="4" className="p-2 text-center">
                            <p className={`${styles.indicator} `}>
                                Suma de plată
                            </p>
                            <p className={`${styles.indicatorVal} ${sort=='totalAmount' ? styles.active : ''}  mb-0`} suppressHydrationWarning>
                                { fromTotalCost}
                            </p>
                                {toTotalCost && 
                                <div className={`${styles.indicatorVal} ${sort=='totalAmount' ? styles.active : ''} mb-0 mt-2`} suppressHydrationWarning>
                                    <p className="d-flex justify-content-center">
                                        <FontAwesomeIcon icon={faArrowsAltV} className="d-block" width="16px" height="16px" />
                                    </p>
                                    {toTotalCost}
                                </div> 
                            }
                        </Col>
                        ;


    let installmentColumn = <Col xs="4" className="p-2 text-center">
                                <p className={`${styles.indicator} `}>
                                   Rata lunară
                                </p>
                                <p className={`${styles.indicatorVal} ${ sort=='monthlyPayment' && styles.active} mb-0`}                        
                                    suppressHydrationWarning >
                                    {fromPayment}
                                </p>
                                <p className={`mb-0 ${styles.rateType} `}>{details.rateType}</p>
                            </Col>;
    
    let detailsCol = <Col xs="6" md="4" className="py-3 text-center">
                        <Button variant="link" aria-label="Detalii" onClick={handleViewDetails}>
                            <u>Detalii</u>
                            <FontAwesomeIcon className="ml-2" icon={faChevronRight} height="16" width="16" />
                        </Button>
                    </Col>;

    const eligibilityOptions = {
        high: 'Foarte bună',
        average: 'Medie',
        low : 'Scăzută',
        poor : 'Foarte scăzută'
    };

    let eligibilityCol = details.hasOwnProperty('approvalChance') && 
                        <Col xs="12" md="4" className={`text-center ${styles[details.approvalChance]} `}>
                            <p className={styles.indicator}>Șansă obținere credit</p>
                            <p className={`${styles.indicatorVal} mb-0`}  >
                                   {eligibilityOptions[details.approvalChance]}
                                </p>
                        </Col>;

    function handleViewDetails () {
        viewDetails(details.id);
    }

    let showOffer = !details.hasOwnProperty('visible') || details.visible ? '' : 'd-none';

    

    return (
        <div className={`${styles.root} ${showOffer} mb-5 p-3`}>
            <Row className={`${styles.product} justify-content-between mb-0`} >
                <Col xs="12" md="4">
                    { (details.showLogo && details.providerLogo) ?
                    <Image src={details.providerLogo} 
                            height={details.logoSize.height}
                            width={details.logoSize.width}
                            alt={details.provider}
                    /> 
                    : 
                    <p className="mb-0 font-weight-bold">{details.provider}</p> }

                    <p className={`${styles.productName} mb-0`} >{details.product}</p>
                </Col>
                {benefitsCol}
            </Row>

            <Row className={`${styles.product} mb-0 justify-content-center`}>  
                {aprColumn}
                {totalCostColumn}  
                {installmentColumn}
            </Row>
            <Row className={ `mb-0 justify-content-between align-items-center`} >  
                {eligibilityCol}
                {detailsCol}
                {applyCol}
                {webLinkCol}
            </Row>
            {/* { details.hasOwnProperty('apply') && <BCTeaser /> } */}
        </div>
    );
}

export default LoanInfo;